import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { CommonService } from "src/@services/common.service";
import { FormService } from "src/@services/form.service";
import { InnerPagesService } from "src/app/pages/common-layout/inner-pages.service";
import { responseMessageStatus, ResponseStatus } from "../../enum";

@Component({
  selector: "app-tag-form",
  templateUrl: "./tag-form.component.html",
  styleUrls: ["./tag-form.component.scss"],
  standalone: false,
})
export class TagFormComponent implements OnInit {
  @Input() selectedTagGroup: any;
  @Input() listOfGroups: any;
  @Input() selectedTagData: any;
  // @Input() tagGroupData: any;

  @Output() getData = new EventEmitter();
  siteId: any;

  constructor(
    public _cS: CommonService,
    public _fS: FormService,
    private route: ActivatedRoute,
    private _iS: InnerPagesService,
    private cdref: ChangeDetectorRef
  ) {
    _fS.tagForm_fb();
  }

  ngOnInit(): void {
    this.siteId = this.route.snapshot.paramMap.get("siteId");
    if (this.selectedTagData != null) {
      this._fS.tagForm.patchValue({
        tagName: this.selectedTagData.name,
        tagGroup: this.selectedTagGroup.id,
      });
    }
    this.getTagGroupsForDropdown();
  }
  checkTagGroupData(event: any) {
    this.selectedTagGroup = this.listOfGroups.find((x: any) => x._id == event);
    this.getData.emit(this.selectedTagGroup);
  }
  getTagGroupsForDropdown() {
    this._cS.isLoadingTags = true;
    this._iS.getTagsDropdownList(this.siteId).subscribe((response: any) => {
      if (response) {
        if (response.responseStatus == ResponseStatus.success) {
          this._cS.isLoadingTags = false;
          this.listOfGroups = response.result;
          this.listOfGroups = this.listOfGroups.filter(
            (x) => x.Name != "Uncategorized"
          );
        } else {
          this._cS.isLoadingTags = false;
          this._cS.displayMessage(
            responseMessageStatus.error,
            response.message
          );
        }
      }
    });
  }
  // to avoid expression ng-zorro error
  ngAfterContentChecked() {
    this.cdref.detectChanges();
  }
}
